const mlsGetBounds = async ( locationString: string ): Promise<Record<string, any>> => {
    const googleURL = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(locationString)}&key=AIzaSyBhngeqpbUIOlwNQYlRrllEl94NAzAxgvg`;

    try {
        const response: Response = await fetch( googleURL );
        if ( ! response.ok ) {
            throw new Error( `Error fetching location details: ${response.statusText}` );
        }
        const json = await response.json();
        // Check if the response has results
        if ( json.status === 'OK' && json.results.length > 0 ) {
            const location = {
                string: json.results[0].formatted_address,
                bounds: json.results[0].geometry.bounds ? json.results[0].geometry.bounds : json.results[0].geometry.viewport,
            }
            return location;
        } else {
            throw new Error( `No valid results found for location: ${locationString}` );
        }
    } catch ( error ) {
        console.error( 'Error fetching Google Maps API data:', error );
        throw error;
    }
}
export default mlsGetBounds;